import { useForm, UseFormProps, FormProvider, useWatch } from 'react-hook-form';
import FormContentCreateOrEditCreator from '../formContentCreateOrEditCreator';
import FormCreateOrEditCreatorFooter from './FormCreateOrEditCreatorFooter';
import FormCreateOrEditCreatorHeader from './FormCreateOrEditCreatorHeader';
import FormLabelErrorMessage from '../FormLabelErrorMessage';
import { ScrollArea } from '@/components/ui';
import { TFormData, TProps } from '.';
import { nameof } from '@/functions';

const VARIABLES = {
  formConfig: {
    reValidateMode: 'onBlur',
    mode: 'all'
  } as UseFormProps<TFormData>
};

const FormCreateOrEditCreator = ({ creator, callback, textBtnCancel, requireReferralCode = false, readonly = false }: TProps) => {

  const formMethods = useForm<TFormData>({ ...VARIABLES.formConfig, values: creator });
  const errorMessage = useWatch({ control: formMethods.control, name: 'errorMessage' });

  return (
    <FormProvider {...formMethods}>
      <FormCreateOrEditCreatorHeader readonly={readonly} />
      <ScrollArea className='flex-1 overflow-auto py-3'>
        <FormContentCreateOrEditCreator
          requireReferralCode={requireReferralCode}
          readonly={readonly}
          fieldNames={{
            referralCode: `${nameof<TFormData>('referralCode')}`,
            username: `${nameof<TFormData>('username')}`,
            gender: `${nameof<TFormData>('gender')}`,
            links: `${nameof<TFormData>('links')}`,
            type: `${nameof<TFormData>('type')}`,
            coinsAmount: `${nameof<TFormData>('coinsAmount')}`,
            paymentInfo: {
              phoneNumberOwnerName: `${nameof<TFormData>('paymentInfo.phoneNumberOwnerName')}`,
              phoneNumber: `${nameof<TFormData>('paymentInfo.phoneNumber')}`,
              method: `${nameof<TFormData>('paymentInfo.method')}`,
              email: `${nameof<TFormData>('paymentInfo.email')}`,
              iban: `${nameof<TFormData>('paymentInfo.iban')}`,
              bic: `${nameof<TFormData>('paymentInfo.bic')}`
            }
          }} />
      </ScrollArea>
      <FormLabelErrorMessage errorMessage={errorMessage} />
      <FormCreateOrEditCreatorFooter
        textBtnCancel={textBtnCancel}
        fieldNames={{
          links: `${nameof<TFormData>('links')}`
        }}
        readonly={readonly}
        callback={callback} />
    </FormProvider>
  );

};

export default FormCreateOrEditCreator;
